import { FETCH_AI_INVOICE } from "@/modules/ai-invoices/store/ai-invoices.module";

export const aiInvoiceFormMixin = {
  props: {
    aiInvoiceId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      aiInvoiceData: null,
      isLoadingAiInvoice: false
    };
  },
  methods: {
    async loadAiInvoiceData() {
      if (!this.aiInvoiceId) return null;

      this.isLoadingAiInvoice = true;
      try {
        const response = await this.$store.dispatch(
          FETCH_AI_INVOICE,
          this.aiInvoiceId
        );
        this.aiInvoiceData = response.data || response;

        if (this.prefillFromAiInvoice) {
          this.prefillFromAiInvoice();
        }

        this.$notify({
          group: "notify",
          type: "info",
          title: this.$t("LABELS.INFO"),
          text: this.$t("LABELS.FORM_PREFILLED_FROM_AI_INVOICE")
        });

        return this.aiInvoiceData;
      } catch (error) {
        console.error("Error loading AI invoice:", error);
        this.$notify({
          group: "notify",
          type: "error",
          title: this.$t("ALERTS.ERROR"),
          text: this.$t("LABELS.ERROR_LOADING_AI_INVOICE")
        });
        return null;
      } finally {
        this.isLoadingAiInvoice = false;
      }
    },

    prefillBasicInvoiceInfo(form) {
      if (!this.aiInvoiceData) return;

      form.invoiceNumber = this.aiInvoiceData.invoiceNumber;
      form.invoiceDate = this.aiInvoiceData.date;
      form.totalWithVat = this.aiInvoiceData.totalAmount;
      form.vat = this.aiInvoiceData.taxAmount;

      // Calculate total without VAT
      const total = parseFloat(this.aiInvoiceData.totalAmount || 0);
      const vat = parseFloat(this.aiInvoiceData.taxAmount || 0);
      form.totalNoVat = (total - vat).toFixed(2);
    },

    autoMatchByName(items, supplierName, itemNameKey = "name") {
      if (!supplierName || !items.length) return null;

      const name = supplierName.toLowerCase().trim();

      // Try exact match first
      let matched = items.find(
        item =>
          item[itemNameKey] && item[itemNameKey].toLowerCase().trim() === name
      );

      // Try partial match
      if (!matched) {
        matched = items.find(
          item =>
            item[itemNameKey] &&
            (item[itemNameKey].toLowerCase().includes(name) ||
              name.includes(item[itemNameKey].toLowerCase()))
        );
      }

      return matched;
    },

    calculateTotalNoVat(totalAmount, taxAmount) {
      const total = parseFloat(totalAmount || 0);
      const vat = parseFloat(taxAmount || 0);
      return (total - vat).toFixed(2);
    }
  }
};
